import React from 'react'
import Dialog from 'material-ui/Dialog'
import muiTheme from '../../assets/mui-theme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

/** @module */

/**
 * React component for a dialog alerting the user that they are offline
 * @param {Object} props - Component properties
 * @param {Object} props.onClick - Action when button is touch/tapped
 * @param {Object} props.open - Whether or not the dialog is open
 * @returns {JSX} React component for a splash/loading screen
 */
const OfflineDialog = props => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <Dialog modal={true} open={props.open}>
      {
        'Your connection has been interrupted. We will automatically reconnect when service is restored.'
      }
    </Dialog>
  </MuiThemeProvider>
)

export default OfflineDialog
